;
(function () {
    'use strict';
    angular.module('finanzaApp').service('CblPromotorMaskSrvc', function () {
        var codicePromotore = '';
        var isFiliale = false;
        var performedSearch = false;
        var commissions = [];
        var formField = {
            descrCompany: '',
            descrProd: '',
            reasonProvv: '',
            ndgCustomer: '',
            headerCustomer: '',
            dateFrom: '',
            dateTo: ''
        };

        return {
            codicePromotore: codicePromotore,
            isFiliale: isFiliale,
            performedSearch: performedSearch,
            commissions: commissions,
            formField: formField,
        };
    });
}());
